import isMobile from '../lib/isMobile'

var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop

export default class Header {
  constructor(el) {
    this.el       = el
    this.scrolled = 1
    this.position = 0

    this.setBodyHeight()

    window.addEventListener('resize', this.setBodyHeight.bind(this), false)
    //window.addEventListener('scroll', this.check.bind(this), false)
  }

  setBodyHeight() {
    this.bodyHeight = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.clientHeight,
      document.documentElement.scrollHeight,
      document.documentElement.offsetHeight
    )
  }

  /*check() {
    let scroll       = document.body.scrollTop
    let onBottom     = this.position + window.innerHeight + 50 > this.bodyHeight
    let tuck         = false
    let scrolledDown = false
    let scrolled     = (scroll > this.position) ? -1 : 1
    let onContent    = window.pageYOffset > 60

    this.position = scroll

    scrolledDown = scrolled == -1

    tuck = isMobile() && onContent && scrolledDown && !onBottom

    this.el.classList.toggle('-tuck', tuck)
  }*/
}



// WEBPACK FOOTER //
// ./src/javascript/features/header.js